import { Box, Grid } from "@mui/material";
import ExplorerGrid, { useExplorerGrid } from "common/ExplorerGrid";
import useToolbarProps from "qubCommon/ExplorerToolbar/useToolbarProps";
import { DateInput, TextInput } from "qubCommon/Inputs";

const TRANSACTIONS_EXPLORER_KEY = "TransHeaderExpenses-Expl";

const ExpenseTransactionsExplorer = ({ applicationId, childId }) => {
  const { status, critParams, ...toolbarRest } = useToolbarProps({
    webPageKey: TRANSACTIONS_EXPLORER_KEY,
    hideAddNew: true,
  });

  const getApplicationCriteria = (criteriaValues = {}) => {
    if (!applicationId) return [];

    const criteria = [
      {
        fldName: "ApplicationId",
        operator: "=",
        value1: applicationId,
      },
    ];

    if (childId) {
      criteria.push({
        fldName: "ChildId",
        operator: "=",
        value1: childId,
      });
    }

    if (criteriaValues?.dateFrom) {
      criteria.push({
        fldName: "TransDate",
        operator: ">=",
        value1: criteriaValues.dateFrom,
      });
    }

    if (criteriaValues?.dateTo) {
      criteria.push({
        fldName: "TransDate",
        operator: "<=",
        value1: criteriaValues.dateTo,
      });
    }

    return criteria;
  };

  const { explParams, ...explorerRest } = useExplorerGrid({
    explorerDataKey: TRANSACTIONS_EXPLORER_KEY,
    xlsxName: "Δαπάνες ΜΗΔ",
    navUrl: `/expenses/${applicationId}/transactions/{:id}`,
    status,
    additionalCritFldsSearch: getApplicationCriteria,
  });

  return (
    <Box
      sx={{
        border: "1px solid rgba(0, 0, 0, 0.125)",
        borderRadius: "0.25rem",
        backgroundColor: "#fff",
        overflow: "hidden",
        p: 1.5,
      }}
    >
      <Box>
        <ExplorerGrid
          explParams={explParams}
          title="Αναλυτικές Δαπάνες"
          breadcrumbs={[{ name: "Αναλυτικές Δαπάνες", path: "expenses" }]}
          autoRowHeights
          stickyHeaders
          submitFiltersOnEnter
          {...explorerRest}
          {...toolbarRest}
        >
          <Grid item xs={12} md={6} lg={3}>
            <TextInput
              id="Search"
              name="searchFieldValue"
              label="Αναζήτηση"
              defaultValue={critParams?.searchFieldValue ?? ""}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={2}>
            <DateInput
              fixedPadding={8}
              name="dateFrom"
              label="Από Ημ/νία"
              defaultValue={critParams?.dateFrom ?? ""}
              isFullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={2}>
            <DateInput
              fixedPadding={8}
              name="dateTo"
              label="Έως Ημ/νία"
              defaultValue={critParams?.dateTo ?? ""}
              isFullWidth
            />
          </Grid>
        </ExplorerGrid>
      </Box>
    </Box>
  );
};

export default ExpenseTransactionsExplorer;
